/* eslint-disable react/prop-types */
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { FaMinus, FaPlus, FaShoppingCart } from 'react-icons/fa';
import { cartContext } from '../Context/CartContext';
import { useCartDrawer } from '../Context/CartDrawerContext';
import styles from './Store.module.css';

// Misma logica que AddItem / BtnPostAdd, con un marcado compacto que entra en la tarjeta
const AgregarCarrito = ({ producto }) => {
    const [t] = useTranslation('global');
    const { abrirCarrito } = useCartDrawer();
    const { addToCart, cartLocal } = useContext(cartContext);
    const [cantidad, setCantidad] = useState(1);

    const stock = Number(producto.Stock) || 0;
    // El estado "Sin stock" ya se informa con la etiqueta de la tarjeta
    if (stock <= 0) return null;

    const enCarrito = !cartLocal || cartLocal.length === 0
        ? undefined
        : cartLocal.find((item) => item.Alias === producto.Alias);

    const restar = () => setCantidad((c) => Math.max(1, c - 1));
    const sumar = () => setCantidad((c) => Math.min(stock, c + 1));

    const agregar = () => {
        if (!enCarrito || stock - enCarrito.contador - cantidad >= 0) {
            addToCart(producto, cantidad);
        } else {
            toast.error(t('producto.stock-insuficiente'), { autoClose: 400 });
        }
    };

    const agregarUnoMas = () => {
        if (!enCarrito || stock - enCarrito.contador - 1 >= 0) {
            addToCart(producto, 1);
            abrirCarrito();
        } else {
            toast.error(t('producto.stock-insuficiente'), { autoClose: 400 });
        }
    };

    // Ya esta en el carrito: ir al carrito o sumar una unidad mas
    if (enCarrito) {
        return (
            <div className={styles.agregar}>
                <button type="button" className={`${styles.btn} ${styles.btnRojo} ${styles.agregarBtn}`} onClick={() => abrirCarrito()}>
                    <FaShoppingCart aria-hidden="true" /> {t('producto.ir-carrito')}
                </button>
                <button
                    type="button"
                    className={`${styles.btn} ${styles.btnGhost} ${styles.agregarMas}`}
                    onClick={agregarUnoMas}
                    aria-label={t('producto.agregar')}
                    title={t('producto.agregar')}
                >
                    <FaPlus aria-hidden="true" />
                </button>
            </div>
        );
    }

    return (
        <div className={styles.agregar}>
            <div className={styles.stepper} role="group" aria-label={t('store.cantidad')}>
                <button type="button" onClick={restar} disabled={cantidad <= 1} aria-label={t('store.restar-uno')}>
                    <FaMinus aria-hidden="true" />
                </button>
                <span aria-live="polite">{cantidad}</span>
                <button type="button" onClick={sumar} disabled={cantidad >= stock} aria-label={t('store.sumar-uno')}>
                    <FaPlus aria-hidden="true" />
                </button>
            </div>
            <button type="button" className={`${styles.btn} ${styles.btnRojo} ${styles.agregarBtn}`} onClick={agregar}>
                <FaShoppingCart aria-hidden="true" /> {t('store.agregar')}
            </button>
        </div>
    );
};

export default AgregarCarrito;
